﻿function changeKendoNumText(text: kendo.ui.NumericTextBox, value: number) {
    if (text.value() !== value) {
        text.value(value);
        text.trigger('change');
    }
}

function changeKendoText(text: kendo.ui.TextBox, value: string) {
    if (text.value() !== value) {
        text.value(value);
        text.trigger('change');
    }
}

window.changeKendoNumText = changeKendoNumText;
window.changeKendoText = changeKendoText;